import React from 'react';
import { XIcon } from './icons';

interface ModalProps {
  isOpen: boolean;
  onClose: () => void;
  title?: string;
  children: React.ReactNode;
  containerClassName?: string;
  zIndex?: string;
  // When false, the default header (title + close button) is hidden so callers can render a fully custom header
  showHeader?: boolean;
  // Optional classes for the scrollable body container (defaults to padding)
  bodyClassName?: string;
}

const Modal: React.FC<ModalProps> = ({ isOpen, onClose, title, children, containerClassName, zIndex = 'z-50', showHeader = true, bodyClassName }) => {
  if (!isOpen) return null;

  return (
    <div
      className={`fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center ${zIndex}`}
      aria-labelledby="modal-title"
      role="dialog"
      aria-modal="true"
      onClick={onClose}
    >
      <div
        className={`bg-white rounded-lg shadow-xl transform transition-all mx-4 w-full max-w-sm sm:max-w-md md:max-w-lg lg:max-w-xl xl:max-w-2xl 2xl:max-w-4xl max-h-[90vh] flex flex-col ${containerClassName || ''}`}
        onClick={(e) => e.stopPropagation()}
      >
        {showHeader && (
          <div className="flex justify-between items-center px-3 py-2 sm:px-4 sm:py-3 border-b border-slate-200">
            {title && <h3 id="modal-title" className="text-base sm:text-lg leading-6 font-medium text-gray-900">{title}</h3>}
            <button onClick={onClose} className="p-1 rounded-full text-gray-400 hover:text-gray-600 hover:bg-slate-100 focus:outline-none focus:ring-2 focus:ring-slate-400">
              <XIcon className="h-5 w-5 sm:h-6 sm:w-6" />
            </button>
          </div>
        )}
        <div className={`${bodyClassName ?? 'p-2 sm:p-3'} overflow-y-auto flex-1`}>
          {children}
        </div>
      </div>
    </div>
  );
};

export default Modal;
